import { render, staticRenderFns } from "./widget-profile.vue?vue&type=template&id=2932f252&"
import script from "./widget-profile.vue?vue&type=script&lang=js&"
export * from "./widget-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports